import { Category, ReactionType } from '../../../services/category-service';

export const isWithEmotions = (reactionType?: Category['reactionType']) =>
  reactionType === ReactionType.MULTIPLE_REACTIONS || reactionType === ReactionType.REACTIONS;
